// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606150222/js/" + chunkId + "." + {"44":"1de42383","225":"e69a3934","481":"b69906e7","486":"4e772a2b","770":"790187d7"}[chunkId] + ".0.2893521376016387.chunk.js";
};